var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRequestUploadicon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_1240_121)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4444 19H8.55556C8.24873 19 8 18.7314 8 18.4V7.6C8 7.26863 8.24873 7 8.55556 7H17.4444C17.7513 7 18 7.26863 18 7.6V18.4C18 18.7314 17.7513 19 17.4444 19ZM16.8889 17.8V8.2H9.11111V17.8H16.8889ZM10.7778 10H15.2222V11.2H10.7778V10ZM10.7778 12.4H15.2222V13.6H10.7778V12.4ZM10.7778 14.8H15.2222V16H10.7778V14.8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1240_121",
    x1: 14.7105,
    y1: -5.81579,
    x2: 13,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF03CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0CB2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRequestUploadicon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/request-uploadicon.27d34e8a04c6a4ab7ef72187e1c3efef.svg";